export const normalizeActions = (actions: string[]): { id: number; name: string }[] =>
  (actions ?? []).map((action, index) => ({
    id: index,
    name: action,
  }));

export const sanitizeFileName = (fileName: string) => fileName.replace(/\.[^/.]+$/, '').replace(/\s+/g, '');
